import { getLocal, setLocal } from '@/utils/index'

export default class Page {
  static PAGE_SIZE_LIST = [50, 100, 200, 500]
  static MIN_PAGE_SIZE_LIST = [10, 20, 50]

  constructor(pageNum = 1, pageSize = 50, total = 0, usePageSize = false) {
    this.pageNum = pageNum
    this.pageSize = pageSize
    this.total = total
    this.usePageSize = usePageSize
    this.pages = 0
  }

  sync(data) {
    const { current, size, total, currentPage, pageSize, pages, pageNum } = data
    this.pageNum = current || currentPage || pageNum || pages || 0
    this.pageSize = size || pageSize || 0
    this.pages = pages

    this.total = total || 0
  }
  // 初始化页码
  init() {
    this.pageNum = 1
  }
}
